module.exports = __webpack_public_path__ + "assets/img/contact-banner.6ca4aef2.png";